import * as Cesium from "cesium";
import { Viewer as CesiumViewer } from "cesium";
import "cesium/Build/Cesium/Widgets/widgets.css";
import React, { useEffect, useRef } from "react";
import useViewerStore from "./stores/useViewerStore";

Cesium.Ion.defaultAccessToken = process.env.REACT_APP_CESIUM_TOKEN || "";

const CesiumMap = ({ children }: { children?: React.ReactNode }) => {
  const divRef = useRef<HTMLDivElement>(null);
  const { viewer, setViewer } = useViewerStore();

  useEffect(() => {
    if (divRef.current && !viewer) {
      const v = new CesiumViewer(divRef.current, {
        animation: false,
        timeline: false,
        fullscreenButton: true,
        baseLayerPicker: true,
        geocoder: true,
        homeButton: false,
        // infoBox: false,
        sceneModePicker: false,
        selectionIndicator: false,
        navigationHelpButton: true,
        navigationInstructionsInitiallyVisible: true,
      });

      setViewer(v);
    }
  }, [setViewer, viewer]);


  useEffect(() => {
    if (viewer) {
      const position = Cesium.Cartesian3.fromDegrees(
        127.04963205770692,
        37.538491931968686,
        206.73204732780167
      );
      viewer.camera.flyTo({
        duration: 1,
        destination: position,
        orientation: {
          heading: 0.978823452425793,
          pitch:-0.34326038565677863,
          roll: 0.0000044044506495311,
        },
      });
    }
  }, [viewer]);

  return (
    <div
      ref={divRef}
      style={{ width: "100dvw", height: "100dvh", backgroundColor: "green" }}
    >
      {children && children}
    </div>
  );
};

export default CesiumMap;
